import { useEffect } from "react";
import { useState } from "react";

export default function RecentActivity({ actions }) {
    const [currentTime, setCurrentTime] = useState(new Date());

    const [fade, setFade] = useState(false);

    useEffect(() => {
        setFade(true);
        const timeout = setTimeout(() => setFade(false), 500);
        return () => clearTimeout(timeout);
    }, [actions]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 60000);

        return () => clearInterval(intervalId);
    }, []);

    const calculateTimeDifference = (timestamp) => {
        const now = currentTime;
        const past = new Date(timestamp);
        const difference = now - past;

        const minutes = Math.floor(difference / (1000 * 60));
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));

        if (minutes < 60) {
            return minutes <= 0 ? 'току що' : `преди ${minutes} мин.`;
        } else if (hours < 24) {
            return `преди ${hours} ч.`;
        } else {
            return `преди ${days} ден.`;
        }
    };
    
    return (
        <div className="card col-lg-4 w-100-l">
            <div className="card-body">
                <h5 className="card-title use-font">Последни действия</h5>

                <div className="activity">

                    {actions.map((x, i) =>
                        <div key={ i} className={`activity-item d-flex ${(i == 0 && fade) ? 'fadeRight' : ''}`}>
                            <div className="activite-label w-20 text-end w-30-mob">{calculateTimeDifference(x.actionDate)}</div>
                            <i className={`bi bi-circle-fill activity-badge  align-self-start ${x.actionStatus == 4 ? 'text-success' : x.actionStatus == 0 ? 'text-warning' : x.actionStatus == 1 ? 'text-primary' : (x.actionStatus == 2 || x.actionStatus == 9 || x.actionStatus == 100 || x.actionStatus == 101 || x.actionStatus == 102 || x.actionStatus == 10) ? 'text-danger' : x.actionStatus == 30 ? 'text-edit' : 'text-primary'}`}></i>
                            <div className="activity-content">
                                {x.actionStatus == 1 ? `${x.childName} ${x.message}` : (x.actionStatus == 9 || x.actionStatus == 4 || x.actionStatus == 100 || x.actionStatus == 101 || x.actionStatus == 102 || x.actionStatus == 10) ? `Рег.№ ${x.regId} - ${x.message}` : (x.actionStatus == 30 || x.actionStatus == 0) ? `${x.message} № ${x.regId}` : x.message}
                            </div>
                        </div>
                    )}

                </div>

            </div>

        </div>
    )
}